<template>
  <div class="resident-warpper">
    <div class="bg-white">
      <el-form :model="competitionForm" :rules="rules" ref="competitionForm" label-width="100px"
               class="demo-noticeForm">
        <el-form-item label="竞赛名称：" prop="name">
          <el-input v-model="competitionForm.name" placeholder="请输入竞赛名称"></el-input>
        </el-form-item>
        <el-form-item label="竞赛时间" required>
          <el-col :span="11">
            <el-form-item prop="date1">
              <el-date-picker type="datetime" placeholder="请选择竞赛开始时间" v-model="competitionForm.date1"
                              style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line flex align-center justify-center" :span="2">-</el-col>
          <el-col :span="11">
            <el-form-item prop="date2">
              <el-date-picker type="datetime" placeholder="请选择竞赛结束时间" v-model="competitionForm.date2"
                              style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="排序时间：" prop="date3">
          <el-date-picker type="datetime" placeholder="请选择排序时间" v-model="competitionForm.date3"
                          style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="答题时长：" prop="time">
          <el-input-number v-model="competitionForm.time" :min="1" :max="120"
                           label="请输入答题时长（分钟）"></el-input-number>
          <span class="margin-left-xs font-size-lg">分钟</span>
        </el-form-item>

        <el-form-item label="试题分类：" prop="mold">
          <el-select v-model="competitionForm.mold" multiple placeholder="请选择试题分类(可多选)" style="width: 100%"
                     @change="getNum">
            <el-option
              v-for="item in moldList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="试题数量：" prop="num">
          <el-input v-model="competitionForm.num" placeholder="请输入试题数量">
            <template slot="append"><span style="color: #e4393c;">可用数量：{{ competitionForm.total }}</span></template>
          </el-input>
        </el-form-item>
        <el-form-item label="参与人员：" prop="partake">
          <el-select v-model="competitionForm.partake" multiple placeholder="请选择参与人员" style="width: 100%">
            <el-option label="志愿者队长" :value="1"></el-option>
            <el-option label="志愿者" :value="2"></el-option>
            <el-option label="居民" :value="3"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="竞赛规则：" prop="content">
          <VueUditorWrap v-model="competitionForm.content" :config="myConfig"></VueUditorWrap>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" class="submit-btn" @click="submitForm('competitionForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>

import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig, zhDate} from "@/utils/utils";
import {
  getQuestionNumByCate,
  questionCateList,
  QuestionRaceDetail,
  updateQuestionRace
} from "@/api/study";

export default {
  name: "competition-edit",
  data() {
    var checkNum = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入试题数量'));
      } else if (Number(value) > Number(this.competitionForm.total)) {
        return callback(new Error('请输入试题数量不能大于可用数量'));
      } else {
        callback();
      }
    }
    return {
      id: '',
      myConfig: bdEditConfig(),
      moldList: [],
      competitionForm: {
        name: '',
        date1: '',
        date2: '',
        date3: '',
        time: '',
        mold: [],
        num: '',
        total: 0,
        partake: [],
        content: '',
      },
      rules: {
        name: [{required: true, message: '请输入竞赛名称', trigger: 'blur'}],
        date1: [{type: 'date', required: true, message: '请选择竞赛开始时间', trigger: 'change'}],
        date2: [{type: 'date', required: true, message: '请选择竞赛结束时间', trigger: 'change'}],
        date3: [{type: 'date', required: true, message: '请选择排序时间', trigger: 'change'}],
        time: [{required: true, message: '请输入答题时长（分钟）', trigger: 'blur'}],
        mold: [{type: 'array', required: true, message: '请选择试题分类(可多选)', trigger: 'change'}],
        num: [{required: true, message: '请输入试题数量', trigger: 'blur'}, {validator: checkNum, trigger: 'blur'}],
        partake: [{type: 'array', required: true, message: '请选择参与人员', trigger: 'change'}],
        content: [{required: true, message: '请输入竞赛规则', trigger: 'blur'}],
      },
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.$emit("setIndex", '/home/competition-list', "双暖为老 / 竞赛编辑", true);
    this.getList()
    if (Number(this.$route.params.id)) this.id = this.$route.params.id, this.getDetail()
  },
  components: {VueUditorWrap},
  methods: {
    //  获取列表
    async getDetail() {
      const res = await QuestionRaceDetail(this.$route.params.id)
      this.competitionForm = {
        name: res.data.name,
        date1: new Date(res.data.race_start_time),
        date2: new Date(res.data.race_end_time),
        date3: new Date(res.data.sort_time),
        time: res.data.answer_min,
        mold: res.data.cate_ids.split(',').map(Number),
        num: res.data.question_num,
        total: 0,
        partake: res.data.join_users.split(',').map(Number),
        content: res.data.race_rule
      }
      await this.getNum()
    },
    //  获取列表
    async getList() {
      const res = await questionCateList('', 1, 1000)
      this.moldList = res.data
    },
    //  获取分类下的题目
    async getNum() {
      const res = await getQuestionNumByCate(this.competitionForm.mold.join(','))
      this.competitionForm.total = res.data
    },
    //  提交试题
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitQuestion()
        }
      });
    },
    async submitQuestion() {
      let _state = await updateQuestionRace(
        this.competitionForm.name,
        this.competitionForm.time,
        zhDate(new Date(this.competitionForm.date3), 2),
        zhDate(new Date(this.competitionForm.date1), 2),
        zhDate(new Date(this.competitionForm.date2), 2),
        this.competitionForm.mold.join(','),
        this.competitionForm.num,
        this.competitionForm.partake.join(','),
        this.competitionForm.content,
        this.id
      )
      this.$message.success(_state.info)
      this.$router.go(-1)
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
